import { create } from 'zustand';

/**
 * Permet à une page (ex. fiche store démo) de masquer temporairement
 * la bulle support LyrraOne sans toucher à la logique globale du FAB.
 */
interface SupportChatSuppressState {
  suppressed: boolean;
  setSuppressed: (suppressed: boolean) => void;
}

export const useSupportChatSuppress = create<SupportChatSuppressState>((set) => ({
  suppressed: false,
  setSuppressed: (suppressed) => set({ suppressed }),
}));
